/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoSearchSortBy { 
    field: VideoSearchSortBy.FieldEnum;
    order: VideoSearchSortBy.OrderEnum;
}
export namespace VideoSearchSortBy {
    export type FieldEnum = 'title' | 'description' | 'date' | 'duration_in_seconds' | 'status' | 'gender' | 'category' | 'competition' | 'championship' | 'id';
    export const FieldEnum = {
        Title: 'title' as FieldEnum,
        Description: 'description' as FieldEnum,
        Date: 'date' as FieldEnum,
        DurationInSeconds: 'duration_in_seconds' as FieldEnum,
        Status: 'status' as FieldEnum,
        Gender: 'gender' as FieldEnum,
        Category: 'category' as FieldEnum,
        Competition: 'competition' as FieldEnum,
        Championship: 'championship' as FieldEnum,
        Id: 'id' as FieldEnum
    };
    export type OrderEnum = 'ASC' | 'DESC';
    export const OrderEnum = {
        Asc: 'ASC' as OrderEnum,
        Desc: 'DESC' as OrderEnum
    };
}


